import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import setupAxiosInterceptors from 'global/axios-interceptor'
import "assets/scss/material-dashboard-pro-react.scss?v=1.7.0";
import "assets/scss/Material-Icons.css";
import "assets/scss/Material-Icons-font.css";

setupAxiosInterceptors();
ReactDOM.render(
    <App />, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
